module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"completed":"Fullført"},"en":{"completed":"Completed"}}')
  delete Component.options._Ctor
}
